var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCar1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M719.636,1047.811c592.445-732.663,1995.04-773.613,2407.458-192.5 c227.24,320.19,132.282,798.819,85.429,1034.976c-86.221,434.591-298.831,714.37-345.257,773.715 c-112.649,144.002-386.273,493.785-797.963,573.741c-703.437,136.617-1581.166-558.965-1629.795-1343.737 C411.473,1441.565,668.415,1111.153,719.636,1047.811z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 784.5189,
    y1: 1520.7976,
    x2: 2159.2974,
    y2: 1520.7976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2117.522,722.39L840.411,648.51c-29.414-1.436-55.892,30.663-55.892,57.614v1644.515 c0,37.378,38.181,44.901,67.595,41.897l1265.408-129.233c23.115-2.361,41.776-23.513,41.776-47.254V767.417 C2159.297,743.676,2140.636,723.519,2117.522,722.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M2138.526,709.328l-1279.633-62.95c-29.414-1.447-53.369,19.394-53.369,46.556v1657.364 c0,27.162,23.955,46.716,53.369,43.689l1279.633-131.707c23.114-2.379,41.776-23.697,41.776-47.624V754.706 C2180.302,730.78,2161.641,710.465,2138.526,709.328z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181785483936724224840000004804212241101983647_",
    gradientUnits: "userSpaceOnUse",
    x1: 830.0879,
    y1: 1520.2448,
    x2: 2161.1648,
    y2: 1520.2448
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181785483936724224840000004804212241101983647_)"
    },
    d: "M858.893,2371.511 c-15.866,1.602-28.805-9-28.805-23.637V694.038c0-14.637,12.94-25.934,28.805-25.184L2138.526,729.3 c12.495,0.59,22.638,11.602,22.638,24.547v1462.698c0,12.945-10.143,24.501-22.638,25.763L858.893,2371.511z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2056.052,2203.083 961.576,2308.534 961.576,782.728 2056.052,823.948  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#97A6B7"
    },
    d: "M1618.295,831.416l-437.412,5.472l9.811-98.645 c0.74-12.817,10.007-23.339,22.206-25.214l74.078-11.384c8.721-1.34,16.233-7.105,20.044-15.382l8.032-17.445l193.76,11.964 L1618.295,831.416z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040564327194642823010000011826976694773890714_",
    gradientUnits: "userSpaceOnUse",
    x1: 1180.8826,
    y1: 678.7318,
    x2: 1868.5287,
    y2: 678.7318
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040564327194642823010000011826976694773890714_)"
    },
    d: "M1851.876,767.419 c-2.075-11.16-11.017-18.994-22.283-19.499l-69.894-3.132c-31.724-1.422-54.98-27.194-53.816-59.837l2.697-75.646 c0.499-13.99-9.492-25.2-23.223-26.02l-22.963-1.372c-17.511-1.046-29.17-16.483-26.714-34.332 c4.292-31.194-17.08-58.114-48.056-60.225c-31.219-2.128-60.355,21.723-65.003,53.316c-0.691,4.695-2.276,9.333-4.857,13.473 c-7.214,11.572-19.854,17.943-32.232,17.203l-23.688-1.415c-14.353-0.857-27.992,9.217-31.628,23.391l-19.696,76.785 c-8.518,33.208-40.65,57.206-74.769,55.676l-76.671-3.437c-12.557-0.563-24.88,6.756-30.663,18.231l-46.202,91.677 c-3.784,7.508,0.875,15.619,9.121,15.893l664.896,22.084c7.277,0.242,13.452-7.014,12.112-14.225L1851.876,767.419z  M1578.199,552.826c-9.158-0.568-15.514-8.53-14.182-17.782c1.333-9.253,9.844-16.27,18.998-15.674 c9.139,0.595,15.458,8.555,14.131,17.779C1595.818,546.374,1587.342,553.393,1578.199,552.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M1855.815,769.469c-2.075-11.16-11.017-18.994-22.284-19.499l-69.894-3.133 c-31.724-1.422-54.98-27.195-53.816-59.838l2.697-75.646c0.499-13.99-9.492-25.2-23.223-26.02l-22.964-1.372 c-17.511-1.046-29.17-16.482-26.714-34.332c4.293-31.194-17.08-58.114-48.056-60.225c-31.219-2.127-60.355,21.723-65.004,53.317 c-0.691,4.694-2.276,9.333-4.857,13.473c-7.214,11.572-19.854,17.942-32.233,17.203l-23.688-1.415 c-14.353-0.857-27.992,9.217-31.628,23.391l-19.696,76.785c-8.518,33.209-40.65,57.206-74.769,55.676l-76.671-3.437 c-12.557-0.563-24.88,6.756-30.663,18.231l-46.202,91.677c-3.784,7.508,0.876,15.619,9.122,15.893l664.896,22.085 c7.277,0.242,13.452-7.015,12.112-14.225L1855.815,769.469z M1582.138,554.877c-9.158-0.568-15.514-8.529-14.182-17.782 c1.332-9.253,9.844-16.27,18.998-15.674c9.139,0.595,15.459,8.555,14.131,17.779 C1599.757,548.424,1591.28,555.443,1582.138,554.877z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M1742.026,811.598c-59.31-36.613-104.818-10.653-141.782-51.948 c-39.57-44.207-12.881-102.404-53.825-129.867c-26.212-17.581-49.594-2.074-80.081-6.834 c-11.162-1.742-23.075-6.18-35.454-14.828l-16.426,64.039c-8.518,33.209-40.65,57.205-74.769,55.677l-76.671-3.436 c-12.557-0.563-24.88,6.756-30.663,18.23l-46.201,91.677c-3.784,7.507,0.876,15.619,9.122,15.892l604.254,20.071 C1784.309,846.099,1765.402,826.028,1742.026,811.598z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1949.317,1275.648 1101.672,1280.191 1101.672,1229.859 1949.317,1227.163  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1805.979,1415.456 1088.989,1432.725 1088.989,1380.309 1805.979,1366.316  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1805.979,1501.488 1088.989,1524.493 1088.989,1472.077 1805.979,1452.348  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1805.979,1587.52 1088.989,1616.261 1088.989,1563.845 1805.979,1538.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1805.979,1673.551 1088.989,1708.029 1088.989,1655.613 1805.979,1624.412  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1949.317,1412.003 1855,1414.275 1855,1365.359 1949.317,1363.519  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1949.317,1496.888 1855,1499.915 1855,1450.999 1949.317,1448.404  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1949.317,1581.774 1855,1585.554 1855,1536.639 1949.317,1533.289  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1949.317,1666.659 1855,1671.194 1855,1622.278 1949.317,1618.174  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1805.979,1813.162 1088.989,1856.948 1088.989,1804.532 1805.979,1764.023  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1805.979,1899.194 1088.989,1948.715 1088.989,1896.3 1805.979,1850.055  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1805.979,1985.226 1088.989,2040.483 1088.989,1988.067 1805.979,1936.086  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1805.979,2071.258 1088.989,2132.251 1088.989,2079.835 1805.979,2022.118  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1949.317,1804.409 1855,1810.168 1855,1761.253 1949.317,1755.924  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1949.317,1889.294 1855,1895.808 1855,1846.893 1949.317,1840.809  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1949.317,1974.179 1855,1981.448 1855,1932.532 1949.317,1925.694  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1949.317,2059.064 1855,2067.088 1855,2018.172 1949.317,2010.58  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1101.672,1141.738 1101.672,1192.071 1419.574,1191.58 1419.574,1141.941  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1101.672,965.498 1101.672,1015.831 1419.574,1017.767 1419.574,968.127  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1101.672,1053.618 1101.672,1103.951 1419.574,1104.673 1419.574,1055.035  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053544426502288812830000004057213611883462802_",
    gradientUnits: "userSpaceOnUse",
    x1: 6182.186,
    y1: 2787.5068,
    x2: 6241.2075,
    y2: 2729.3164,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053544426502288812830000004057213611883462802_)"
    },
    d: "M610.593,2796.825h44.884 l55.596-141.283C711.073,2655.542,609.062,2662.683,610.593,2796.825z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020363902242206159030000014506100303464550035_",
    gradientUnits: "userSpaceOnUse",
    x1: 5128.1431,
    y1: 3181.3269,
    x2: 5388.1172,
    y2: 2925.0137,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020363902242206159030000014506100303464550035_)"
    },
    d: "M1658.166,3041.168l-292.112-54.135 c0,0-26.515-225.486,104.058-246.907C1600.684,2718.703,1670.763,2893.365,1658.166,3041.168z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083048029792217012150000009959220671421027489_",
    gradientUnits: "userSpaceOnUse",
    x1: 5166.7739,
    y1: 2950.1658,
    x2: 5422.8071,
    y2: 2950.1658,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083048029792217012150000009959220671421027489_)"
    },
    d: "M1643.782,2775.921 c0.033,0.003,0.067,0.006,0.1,0.01c9.11,0.916,17.474,4.478,25.784,9.593c7.991,4.053,17.635,8.829,17.635,14.926v0.136 c30.774,32.001,51.022,91.143,51.142,157.36c0.159,88.188-35.725,159.472-83.052,167.697c0,0.004,0.097,0.054,0.097,0.054 c-3.193,0.46-42.844,14.818-167.812,0.671c-3.313-53.671-5.267-357.539-5.267-357.539S1582.292,2763.662,1643.782,2775.921z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090267232898738819930000010158964191703017127_",
    gradientUnits: "userSpaceOnUse",
    x1: 5568.688,
    y1: 2636.1401,
    x2: 5308.001,
    y2: 3147.2046,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#B7C0CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090267232898738819930000010158964191703017127_)"
    },
    d: "M1394.287,2941.012 c0,100.875,46.699,184.466,103.295,186.571c55.51,2.065,99.65-75.326,99.546-172.733 c-0.104-97.306-44.333-180.495-99.741-185.99C1440.897,2763.257,1394.287,2840.244,1394.287,2941.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1438.564,2943.324c0.017,71.578,31.141,131.08,69.063,132.831 c37.431,1.728,67.368-53.6,67.301-123.511c-0.066-69.86-30.072-129.166-67.454-132.549 C1469.602,2816.669,1438.548,2871.8,1438.564,2943.324z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068644561865835785980000000526130446876035756_",
    gradientUnits: "userSpaceOnUse",
    x1: 6005.4668,
    y1: 2818.6064,
    x2: 6215.0264,
    y2: 2818.6064,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068644561865835785980000000526130446876035756_)"
    },
    d: "M820.979,2668.517 c0.027,0.003,0.054,0.006,0.082,0.009c7.39,0.788,16.153,3.857,22.895,8.263c6.482,3.491,4.743,7.604,16.284,12.856v0.117 c19.235,27.565,39.414,78.508,39.511,135.546c0.129,75.963-29.971,137.365-68.364,144.45c0,0.004-0.416,0.046-0.416,0.046 c-2.59,0.396-35.003,12.763-136.383,0.578c-2.687-46.231-4.396-307.975-4.396-307.975S771.095,2657.957,820.979,2668.517z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029041254793342774180000001843018283597337764_",
    gradientUnits: "userSpaceOnUse",
    x1: 6340.8066,
    y1: 2549.418,
    x2: 6117.3481,
    y2: 2987.4973,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#B7C0CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029041254793342774180000001843018283597337764_)"
    },
    d: "M618.578,2810.721 c0,86.891,37.885,158.895,83.798,160.708c45.032,1.779,80.84-64.885,80.756-148.788 c-0.084-83.819-35.964-155.475-80.913-160.208C656.391,2657.608,618.578,2723.923,618.578,2810.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M654.498,2812.714c0.014,61.656,25.262,112.908,56.026,114.417 c30.366,1.489,54.652-46.169,54.598-106.39c-0.053-60.176-24.395-111.26-54.721-114.173 C679.677,2703.616,654.484,2751.104,654.498,2812.714z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060708990462335680700000018160110575061452967_",
    gradientUnits: "userSpaceOnUse",
    x1: 4039.7554,
    y1: 2917.6907,
    x2: 4351.6597,
    y2: 2917.6907,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060708990462335680700000018160110575061452967_)"
    },
    d: "M2748.276,2704.972 c0.041,0,0.083,0,0.124,0c11.319,0,19.949,5.706,30.324,10.774c10.006,3.862,16.455,11.541,20.302,18.118v0.162 c42.315,34.325,66.437,103.081,66.437,182.258c0,105.364-44.903,192.198-104.243,204.118c0,0.004,0.566,0.061,0.566,0.061 c-3.967,0.685-52.658,19.221-202.359,8.16c-3.851-61.121-5.869-410.802-5.869-410.802S2672.83,2697.279,2748.276,2704.972z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012448009871065642990000013180167963410081211_",
    gradientUnits: "userSpaceOnUse",
    x1: 4514.6357,
    y1: 2569.8389,
    x2: 4218.6377,
    y2: 3150.1292,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000012448009871065642990000013180167963410081211_)"
    },
    cx: 2571.268,
    cy: 2924.065,
    rx: 119.372,
    ry: 205.525
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008859406299100562910000016695913916712251043_",
    gradientUnits: "userSpaceOnUse",
    x1: 4241.5322,
    y1: 2923.2625,
    x2: 4402.6206,
    y2: 2923.2625,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000008859406299100562910000016695913916712251043_)"
    },
    cx: 2583.141,
    cy: 2923.262,
    rx: 80.545,
    ry: 146.961
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116928047137851003140000014630134953585942688_",
    gradientUnits: "userSpaceOnUse",
    x1: 4413.0469,
    y1: 3590.6687,
    x2: 2169.8896,
    y2: 6418.5366,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116928047137851003140000014630134953585942688_)"
    },
    d: "M571.945,2717.69 c-4.173,18.908,1.169,38.661,14.304,52.887l24.303,26.32c6.662-77.65,46.832-137.374,95.437-137.374 c53.204,0,96.419,71.699,96.419,160.116c0,20.97-2.408,40.949-6.87,59.298l10.627,4.394l574.148,106.342 c-1.557-11.832-4.429-24.089-4.429-36.557c0-11.264-0.173-22.247-0.173-33.015c0-0.071,0-0.071,0-0.142 c19.234-91.535,66.06-161.249,130.391-161.249c71.912,0,131.261,87.072,131.261,194.406c0,29.33-3.871,57.102-11.661,82.041 l85.845,15.869c0.069,0.142,0.345,1.877,0.553,2.019c2.692,2.906,23.44,21.219,124.896,21.219h1119.743 c50.659,0,88.483-44.208,88.483-94.864v-4.181c0-19.412-9.347-37.124-26.706-45.838c0,0,30.996-88.843,6.414-195.114 c-9.846-42.438-27.931-87.639-60.594-131.068c-18.985-25.223-42.443-49.807-71.916-72.903c0,0-127.424-105.704-361.22-133.192 c0,0-193.791-140.871-371.117-234.247c-87.431-46.051-183.232-69.528-282.066-69.528h-648.185 c-112.505,0-222.886,31.34-318.599,90.569l-168.83,104.3c0,0-40.315,24.025-81.405,81.552 c-46.757,65.392-94.51,174.145-85.086,340L571.945,2717.69L571.945,2717.69z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045577857980509768720000010057590330454984581_",
    gradientUnits: "userSpaceOnUse",
    x1: 4584.4277,
    y1: 2684.5901,
    x2: 4441.5796,
    y2: 3483.3765,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EBEFF2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#B7C0CE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045577857980509768720000010057590330454984581_)"
    },
    d: "M1711.808,3051.027 c0.069,0.142,0.215,1.877,0.422,2.019c7.798,4.888,17.643,28.912,277.371,21.219h967.137c50.659,0,88.483-44.208,88.483-94.864 v-4.181c0-1.133,1.563-2.197,1.494-3.33c-1.135-18.066-11.021-34.291-27.384-42.508l-1126.066,10.627 c0,0-106.206-19.341-142.625-0.283c-5.099,2.692-8.754,6.094-10.594,10.415 C1724.742,2985.421,1704.723,3034.518,1711.808,3051.027z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2765.097,2736.536v14.666c0,11.405,4.677,22.246,12.897,30.18 c8.219,7.864,19.269,12.045,30.677,11.549l120.44-5.101c28.907-1.204,56.318-13.249,76.798-33.723l19.836-19.838 c-9.845-42.438-28.339-87.639-61.003-131.068c-0.421,0.071-0.851,0.071-1.272,0.142l-57.814,45.625 c-30.608,24.16-66.876,40.101-105.42,46.263C2779.972,2698.49,2765.097,2715.989,2765.097,2736.536z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022521460375759759450000017341466704528344972_",
    gradientUnits: "userSpaceOnUse",
    x1: 4165.6753,
    y1: 2719.8486,
    x2: 4679.9365,
    y2: 2719.8486,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000022521460375759759450000017341466704528344972_)"
    },
    d: "M2230.512,2719.733 c7.921,9.524,21.14,17.28,29.332,17.294c150.448-0.018,300.753-0.036,450.888-0.053c8.177-0.01,19.745-7.776,25.688-17.271l0,0 c5.902-9.439,3.188-17.029-6.026-17.033c-165.59,0-331.376,0-497.346,0C2223.871,2702.695,2222.573,2710.277,2230.512,2719.733 L2230.512,2719.733z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096024279049133087550000005727506770963100842_",
    gradientUnits: "userSpaceOnUse",
    x1: 4202.8633,
    y1: 2781.3999,
    x2: 4630.3628,
    y2: 2781.3999,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000096024279049133087550000005727506770963100842_)"
    },
    d: "M2281.318,2781.322 c8.374,9.972,20.51,18.16,27.216,18.147c122.253-0.041,244.41-0.082,366.456-0.122c6.669,0.002,17.166-8.165,23.417-18.138l0,0 c6.236-9.914,4.915-17.891-2.775-17.876c-138.272,0.029-276.677,0.058-415.215,0.087 C2272.696,2763.422,2273.029,2771.395,2281.318,2781.322C2281.311,2781.322,2281.311,2781.322,2281.318,2781.322z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2099.545,2796.043c27.443-0.708,49.372-20.608,49.372-44.914v-14.823 c0-23.108-19.894-42.449-45.87-44.716l-48.97-4.271l-291.448-76.751l6.381,36.737c9.661,55.511,52.067,102.227,111.224,122.516 l43.28,14.845c28.484,9.769,58.934,14.396,89.468,13.609L2099.545,2796.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M1750.843,2940.904l121.576,33.344h1175.929 c-1.134-19.235-11.838-35.47-28.201-43.688l-1126.474,10.627C1893.673,2941.188,1787.263,2921.846,1750.843,2940.904z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062885449662403664470000006758134315324587141_",
    gradientUnits: "userSpaceOnUse",
    x1: 1314.4243,
    y1: 2774.7637,
    x2: 962.2292,
    y2: 2614.1135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000062885449662403664470000006758134315324587141_)"
    },
    d: "M985.047,2858.844 c0.076,0,0.145,0,0.221,0c3.909-7.694,6.981-5.311,6.87-9.22c-0.076-2.37-6.995-239.053-0.02-334.991 c6.047-83.11,19.967-98.188,21.198-99.315c3.058-1.712,4.448-5.71,3.113-9.056c-1.453-3.632-5.591-5.506-9.209-4.068 c-5.12,2.048-22.361,16.016-29.232,110.504c-7.029,96.662-0.09,335-0.02,337.377 C978.087,2853.914,981.235,2858.844,985.047,2858.844z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065061520642482627620000010667486200619319486_",
    gradientUnits: "userSpaceOnUse",
    x1: 5643.5732,
    y1: 3110.1526,
    x2: 6318.353,
    y2: 2444.8757,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000065061520642482627620000010667486200619319486_)"
    },
    d: "M571.93,2717.691 l3.944-7.936c-9.423-165.856,38.294-274.604,85.051-339.998c29.471,1.702,68.932,16.367,65.956,83.245 c-4.673,105.635,16.433,160.188,96.706,208.505c38.114,22.883,79.91,42.58,113.701,71.84 c30.177,26.214,44.266,66.454,75.013,91.11c52.001,41.659,122.563,23.167,183.136,20.403 c55.193-2.55,180.273-5.172,180.273,75.099c0,0.07,0,0.07,0,0.142c0,10.769,0.172,21.751,0.172,33.015 c0,12.469,2.991,24.724,4.545,36.556l-574.203-106.341l-10.657-4.393c4.464-18.35,6.855-38.327,6.855-59.3 c0-88.418-43.222-160.115-96.426-160.115c-48.603,0-88.777,59.724-95.439,137.374l-24.309-26.323 C573.115,2756.349,567.766,2736.598,571.93,2717.691z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009555573563949208770000008924833209860838325_",
    gradientUnits: "userSpaceOnUse",
    x1: 4423.5112,
    y1: 2272.207,
    x2: 5557.0703,
    y2: 2272.207,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009555573563949208770000008924833209860838325_)"
    },
    d: "M1348.147,2143.339 c0,0,75.594,193.445,94.441,221.784c1.771,2.62,4.04,6.534,6.731,8.801c26.139,21.82,90.116,27.15,90.116,27.15h942.271 c-210.203-161.566-389.661-257.736-389.661-257.736H1348.147z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162350662311300956380000006403432438402471832_",
    gradientUnits: "userSpaceOnUse",
    x1: 5760.895,
    y1: 2262.6367,
    x2: 6136.2485,
    y2: 2262.6367,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162350662311300956380000006403432438402471832_)"
    },
    d: "M768.969,2305.924 c0,0,100.536,41.092,235.568,79.774c4.393-20.829,11.478-46.973,22.887-75.736c20.971-53.206,56.533-115.481,116.899-170.388 c-46.694,3.4-101.387,12.468-159.054,32.59C914.49,2196.82,839.319,2238.122,768.969,2305.924z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059311909527987867850000002126175767750620304_",
    gradientUnits: "userSpaceOnUse",
    x1: 5493.3071,
    y1: 2295.4661,
    x2: 5866.1079,
    y2: 2295.4661,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059311909527987867850000002126175767750620304_)"
    },
    d: "M1039.11,2395.335 c67.305,18.206,141.273,35.069,214.667,45.836c41.803,6.093,83.391,10.203,123.415,11.407 c11.693,0.354,23.309,0.496,34.718,0.354c0,0,0-0.07-0.07-0.141c-1.771-7.51-73.401-301.102-139.854-309.816 c-15.304-1.984-39.465-4.535-69.927-5.03c-71.767,53.064-113.287,119.023-137.087,175.418 C1051.578,2345.032,1043.718,2373.654,1039.11,2395.335z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019659119414877950550000003529099912047795889_",
    gradientUnits: "userSpaceOnUse",
    x1: 4671.1377,
    y1: 2652.2388,
    x2: 5210.6396,
    y2: 2120.3347,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000019659119414877950550000003529099912047795889_)"
    },
    d: "M1449.319,2373.833 c26.139,21.821,90.116,27.242,90.116,27.242h942.271c-210.203-161.566-389.661-257.736-389.661-257.736h-13.318 c-20.833,7.694-41.236,26.228-59.3,51.945C1946.525,2299.217,1543.76,2220.448,1449.319,2373.833z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128458521143904487780000001547331257299366822_",
    gradientUnits: "userSpaceOnUse",
    x1: 5501.7568,
    y1: 2461.5029,
    x2: 5519.5396,
    y2: 2443.9709,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000128458521143904487780000001547331257299366822_)"
    },
    d: "M1377.192,2452.578 c11.693,0.354,23.309,0.496,34.718,0.354c0,0,0-0.07-0.07-0.141C1402.418,2452.72,1390.725,2452.649,1377.192,2452.578z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170958525166161270410000016304872197529099139_",
    gradientUnits: "userSpaceOnUse",
    x1: 5687.1865,
    y1: 2477.4277,
    x2: 5846.8252,
    y2: 2320.0376,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000170958525166161270410000016304872197529099139_)"
    },
    d: "M1064.973,2313.364 c-13.395,31.669-21.254,60.291-25.863,81.971c67.305,18.206,141.273,35.069,214.667,45.836 c-10.343-10.271-19.906-23.237-28.263-39.461C1189.025,2331.217,1124.625,2319.101,1064.973,2313.364z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023999113099724704860000002293932887673069715_",
    gradientUnits: "userSpaceOnUse",
    x1: 5890.1665,
    y1: 2375.0344,
    x2: 6049.5039,
    y2: 2217.9407,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3E4177"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000023999113099724704860000002293932887673069715_)"
    },
    d: "M768.969,2305.924 c0,0,100.536,41.092,235.568,79.774c4.393-20.829,11.478-46.973,22.887-75.736c-35.991-3.613-67.097-9.21-84.878-30.606 c-31.176-37.691,7.507-79.916,42.723-107.191C914.49,2196.82,839.319,2238.122,768.969,2305.924z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153682104752453325730000013578738405310796223_",
    gradientUnits: "userSpaceOnUse",
    x1: 5563.9443,
    y1: 2462.748,
    x2: 5786.8457,
    y2: 2242.9861,
    gradientTransform: "matrix(-1 0 0 1 6905.2178 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153682104752453325730000013578738405310796223_)"
    },
    d: "M1414.497,2466.729 c0,0-29.825-117.729-72.208-122.439c-42.383-4.709-163.251-39.243-174.24,18.837c-10.988,58.08,10.989,87.057,72.208,90.62 c61.219,3.563,102.032,0,102.032,0l28.256,30.249C1370.545,2483.996,1416.067,2515.391,1414.497,2466.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1428.625,2466.729c0,0-29.824-117.729-72.207-122.439 c-42.383-4.709-163.252-39.243-174.24,18.837c-10.988,58.08,10.989,87.057,72.207,90.62c61.22,3.563,102.033,0,102.033,0 l28.254,30.249C1384.672,2483.996,1430.195,2515.391,1428.625,2466.729z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M2202.24,1317.024c-120.69,85.068-285.738,52.637-367.918-72.293 c-82.18-124.93-50.851-295.776,69.84-380.844c120.69-85.067,285.738-52.637,367.918,72.293 C2354.26,1061.11,2322.929,1231.957,2202.24,1317.024z M1921.868,890.807c-106.352,74.961-133.959,225.507-61.542,335.595 c72.417,110.088,217.854,138.665,324.205,63.704c106.352-74.961,133.959-225.507,61.542-335.595 C2173.656,844.422,2028.22,815.845,1921.868,890.807z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151521876165776422180000006886440713284162697_",
    gradientUnits: "userSpaceOnUse",
    x1: 6374.4883,
    y1: 1628.9785,
    x2: 6070.4971,
    y2: 1381.5437,
    gradientTransform: "matrix(0.1884 -0.9821 0.9821 0.1884 149.6437 7016.0762)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151521876165776422180000006886440713284162697_)"
    },
    d: "M2169.189,1206.629 c-41.184,222.275,202.637,457.502,462.668,509.126c260.032,51.625,437.802-99.902,478.986-322.177 c41.184-222.275-69.812-431.131-329.844-482.756C2520.969,859.198,2210.374,984.355,2169.189,1206.629z M2384.427,1146.662 l-36.707,198.11c-8.264,44.6-67.765,49.578-83.185,7.06c-15.886-43.801-20.368-87.377-12.694-128.794 s27.412-80.185,57.827-114.794C2339.191,1074.65,2392.691,1102.062,2384.427,1146.662z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132769783869969278390000005098686932136222630_",
    gradientUnits: "userSpaceOnUse",
    x1: 5686.5513,
    y1: 1368.8871,
    x2: 6478.0796,
    y2: 1368.8871,
    gradientTransform: "matrix(0.1884 -0.9821 0.9821 0.1884 149.6437 7016.0762)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132769783869969278390000005098686932136222630_)"
    },
    d: "M3097.969,1391.022 c-20.074,108.342-74.071,198.982-152.045,255.223c-83.959,60.558-191.708,79.986-311.598,56.183 c-125.412-24.898-248.395-92.967-337.408-186.751c-92.608-97.572-133.398-206.42-114.856-306.493 s95.342-185.576,216.253-240.756c116.218-53.039,254.802-69.178,380.215-44.28c119.891,23.802,213.049,83.117,269.406,171.532 C3100.275,1177.792,3118.043,1282.68,3097.969,1391.022z M2238.967,1220.482c-8.094,43.684-3.62,89.48,13.298,136.119 c9.172,25.294,31.867,40.162,57.816,37.876c25.8-2.269,45.627-20.777,50.514-47.15l36.707-198.11 c4.886-26.373-6.919-51.161-30.077-63.15c-23.291-12.062-49.689-6.94-67.254,13.046 C2267.586,1135.965,2247.06,1176.798,2238.967,1220.482z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052089300211870853090000017166600629575697343_",
    gradientUnits: "userSpaceOnUse",
    x1: 5799.4834,
    y1: 1456.265,
    x2: 6364.8926,
    y2: 1456.265,
    gradientTransform: "matrix(0.1884 -0.9821 0.9821 0.1884 149.6437 7016.0762)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000052089300211870853090000017166600629575697343_)"
    },
    cx: 2725.726,
    cy: 1317.12,
    rx: 273.436,
    ry: 283.042
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M2577.946,1688.239l-132.194,93.176l338.81,515.055c7.036,10.696,16.165,19.837,27.116,27.154 l25.826,17.253c16.823,11.239,44.295,7.765,67.405-8.524l0,0c23.11-16.289,36.3-41.475,32.362-61.796l-6.044-31.196 c-2.563-13.228-7.435-25.371-14.471-36.066L2577.946,1688.239z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M2638.271,1924.884c18.155,44.526,81.126,25.947,107.794,81.895 c17.867,37.488-3.952,59.367,21.635,90.752c23.958,29.39,48.865,17.287,66.41,47.915c16.324,28.494-0.036,48.042,17.72,79.979 c12.874,23.154,30.77,29.603,45.438,40.143c11.654,8.373,23.404,20.89,32.256,40.418c6.905-11.767,9.899-24.322,7.747-35.429 l-6.046-31.196c-2.562-13.228-7.434-25.37-14.469-36.067l-253.957-386.063 C2630.724,1873.437,2630.359,1905.477,2638.271,1924.884z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M2693.93,1901.003c4.213,6.405,1.08,16.213-6.999,21.908c-8.079,5.694-18.044,5.118-22.257-1.287 c-4.213-6.405-1.079-16.214,6.999-21.908C2679.752,1894.022,2689.716,1894.598,2693.93,1901.003z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M2798.496,2059.963c4.213,6.405,1.08,16.213-6.999,21.908 c-8.079,5.694-18.043,5.118-22.257-1.287s-1.08-16.214,6.999-21.908C2784.318,2052.982,2794.283,2053.558,2798.496,2059.963z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M2274.359,1167.143c-15.604,48.401-46.032,92.094-89.827,122.962 c-16.838,11.868-34.654,21.131-53.006,27.896c2.649,10.487,5.711,20.906,9.247,31.151c21.287-7.716,41.958-18.377,61.466-32.127 c51.275-36.141,86.409-87.766,103.574-144.775C2295.346,1170.423,2284.865,1168.709,2274.359,1167.143z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105410157567879177590000017112017990611777461_",
    gradientUnits: "userSpaceOnUse",
    x1: 3118.9382,
    y1: 1828.77,
    x2: 3474.2627,
    y2: 1459.884,
    gradientTransform: "matrix(0.8266 -0.5628 0.5628 0.8266 -1327.5828 2490.5439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105410157567879177590000017112017990611777461_)"
    },
    d: "M2150.823,1185.999L2150.823,1185.999 c-145.226,102.362-182.791,307.208-83.903,457.536l190.528,289.638c22.157,33.683,66.496,42.395,99.037,19.459l408.074-287.629 c32.541-22.936,40.957-68.834,18.8-102.517l-190.528-289.638C2493.943,1122.521,2296.049,1083.637,2150.823,1185.999z  M2340.457,1231.295l-218.409,153.944c-6.355,4.479-15.166,1.705-17.887-5.738c-9.983-27.297-1.048-59.108,23.283-76.258 l137.333-96.798c24.332-17.15,56.199-14.099,77.077,5.52C2347.547,1217.313,2346.813,1226.815,2340.457,1231.295z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116202640285703883520000009719010201323864488_",
    gradientUnits: "userSpaceOnUse",
    x1: 3858.4219,
    y1: 890.952,
    x2: 3328.1792,
    y2: 1830.6884,
    gradientTransform: "matrix(0.8266 -0.5628 0.5628 0.8266 -1327.5828 2490.5439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116202640285703883520000009719010201323864488_)"
    },
    d: "M2158.202,1197.216 c-139.019,97.987-175.107,294.779-80.446,438.683l190.526,289.636c18.053,27.445,54.31,34.569,80.824,15.881l408.074-287.629 c26.513-18.688,33.396-56.219,15.342-83.663l-190.528-289.638C2487.335,1136.585,2297.221,1099.229,2158.202,1197.216z  M2358.906,1234.709l-240.55,169.55c-5.985,4.219-14.139,2.615-18.214-3.579l-0.001-0.002 c-23.483-35.699-14.563-84.343,19.924-108.652l137.331-96.797c34.488-24.308,81.484-15.075,104.968,20.625 C2366.438,1222.05,2364.891,1230.491,2358.906,1234.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006686831664212246660000009390999032878023592_",
    gradientUnits: "userSpaceOnUse",
    x1: 3676.7195,
    y1: 2047.9976,
    x2: 3640.2002,
    y2: 1719.3235,
    gradientTransform: "matrix(0.8266 -0.5628 0.5628 0.8266 -1327.5828 2490.5439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006686831664212246660000009390999032878023592_)"
    },
    d: "M2540.745,1447.996l-297.307,209.555 c-13.752,9.693-17.307,29.088-7.944,43.322l22.408,34.065c29.611,45.015,88.867,56.657,132.354,26.005l189.625-133.655 c43.487-30.651,54.736-91.989,25.125-137.004l-22.408-34.064C2573.234,1441.986,2554.497,1438.303,2540.745,1447.996z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132791171859095115710000015077080351725005440_",
    gradientUnits: "userSpaceOnUse",
    x1: 3694.8931,
    y1: 2039.4689,
    x2: 3658.3738,
    y2: 1710.7948,
    gradientTransform: "matrix(0.8266 -0.5628 0.5628 0.8266 -1327.5828 2490.5439)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132791171859095115710000015077080351725005440_)"
    },
    d: "M2516.702,1411.445L2219.394,1621 c-13.751,9.693-32.489,6.01-41.852-8.224l-22.408-34.064c-29.611-45.015-18.362-106.352,25.125-137.004l189.625-133.656 c43.487-30.651,102.743-19.009,132.354,26.006l22.408,34.065C2534.009,1382.356,2530.454,1401.752,2516.702,1411.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#97A6B7"
    },
    d: "M2184.532,1290.105c-62.421,43.997-138.304,52.311-204.989,29.425 c-2.36,10.614-4.789,21.209-7.263,31.797c75.026,24.843,159.953,15.041,229.959-34.302c6.362-4.484,12.459-9.219,18.319-14.159 c-6.222-8.747-12.568-17.406-18.887-26.083C2196.205,1281.443,2190.5,1285.899,2184.532,1290.105z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar1);
export default __webpack_public_path__ + "static/media/car1.40a82be86a01a8d779e2a4012bb623c0.svg";
export { ForwardRef as ReactComponent };